import React from 'react';
import PropTypes, { string } from 'prop-types';
import { Link } from "react-router-dom";
import { withStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { isArray } from 'util';

const styles = theme => ({
    card: {
        display: 'flex',
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        flex: '1 0 auto',
    },
    cover: {
        width: 151,
    },
    websiteUrl: {
        color: theme.palette.primary.main,
        fontWeight: 'bold',
        textDecoration: 'none',
    },
});

const AgentDetail = (props) => {
    const { classes, theme, agentData } = props;

    const getPhotoUrl = (photoURL) => {
        if (isArray(photoURL)) {
            return photoURL[0];
        } else {
            return photoURL;
        }
    };

    const openAgentWebsite = (website) => {
        if (!website.match(/^[a-zA-Z]+:\/\//)) {
            website = 'http://' + website;
        }
        window.open(website, '_blank');
    };

    return (
        <Card className={classes.card}>
            {agentData.agentPhotoURLs ?
                <CardMedia
                    className={classes.cover}
                    image={getPhotoUrl(agentData.agentPhotoURLs)}
                    title="Agent image"
                />
                : ''}
             {agentData.photoURL ?
                <CardMedia
                    className={classes.cover}
                    image={getPhotoUrl(agentData.agentPhotoURLs)}
                    title="Agent image"
                />
                : ''}    
            <div className={classes.details}>

                <CardContent className={classes.content}>
                    <Typography component="h6" variant="h6">
                        {agentData.fullName}
                    </Typography>
                    <Typography variant="subtitle1" color="textSecondary">
                        {
                            (agentData.addressLine1 ? agentData.addressLine1 + ', ' : '') +
                            (agentData.addressCityName ? agentData.addressCityName + ', ' : '') +
                            (agentData.addressStateCode ? agentData.addressStateCode : '')
                        }
                    </Typography>
                    <Typography variant="subtitle2" color="textSecondary">
                        <strong>License Number:&nbsp;</strong> {agentData.licenseNumber ? agentData.licenseNumber : 'N/A'}
                    </Typography>
                    <Typography variant="subtitle2" color="textSecondary">
                    <strong>Mobile Phone:&nbsp;</strong> {agentData.mobilePhone ? agentData.mobilePhone : 'N/A'}
                    </Typography>
                </CardContent>
                {agentData.agentURL ?
                    <CardActions>
                        <Button size="small" onClick={event => openAgentWebsite(agentData.agentURL)} className={classes.websiteUrl}>
                            Visit Agent Website
                    </Button>
                    </CardActions>
                    : ''}
            </div>

        </Card>
    );
}

AgentDetail.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    agentData: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(AgentDetail);
